import ProxyBase from '../../../../core/proxies/ProxyBase'

class AlertSettingProxy extends ProxyBase {
  getAlertSetting(params) {
    return this.get('/setting', params)
  }
  getProfileDetail(params) {
    return this.get('/profileDetail', params)
  }
  getProfileDefault(params) {
    return this.get('/profileDefault', params)
  }
  updateProfileDetail(params) {
    return this.post('/updateProfileDetail', params)
  }
  createProfile(params) {
    return this.post('/createProfile', params)
  }
}

export default new AlertSettingProxy('AlertSetting')
